module.exports = __webpack_public_path__ + "img/html5.ed6b30dc.svg";